"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.collections = undefined;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var collections = exports.collections = function collections() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var collections = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.FETCH_FORT_COLLECTION_SUCCESS:
            nextState = action.response;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.PREVIEW_COLLECTION_ICONS_SUCCESS:
            nextState = (0, _merge2.default)({}, state);
            nextState[action.collection_id].icons = action.response;
            nextState[action.collection_id].iconKeys = action.response.keys;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.SAVE_COLLECTION_SUCCESS:
        case actionTypes.SAVE_COLLECTION_FAILURE:
            return (0, _merge2.default)({}, state);
            break;
        case actionTypes.FEATURE_COLLECTION_SUCCESS:
            nextState = (0, _merge2.default)({}, state);
            nextState[action.collection_id].featured_collection = true;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.UNFEATURE_COLLECTION_SUCCESS:
            nextState = (0, _merge2.default)({}, state);
            nextState[action.collection_id].featured_collection = false;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.FETCH_FEATURED_COLLECTIONS_METADATA_SUCCESS:
            nextState = action.response;
            return (0, _merge2.default)({}, state, nextState);
            break;
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};